package com.vamvisions.main.portfolio.presentation.portfolio

import com.vamvisions.main.core.domain.preferences.Language

sealed interface PortfolioAction {
    data object Retry : PortfolioAction
    data class LanguageChanged(val language: Language) : PortfolioAction
}
